<template>
  <div class="page">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="locations-grey locations-generic contact">
            <section>
              <hr />
              <a href="mailto:Eric@ImejTech.com">
                <i class="far fa-envelope"></i>Email: Eric@IMEJTech.com
              </a>
              <hr />
              <call-button tel-number="7085713860‬" />
              <hr />
              <form
                action="mailto:Eric@ImejTech.com"
                method="post"
                enctype="text/plain"
              >
                Name:
                <input type="text" class="form-control" name="name" />
                <br />E-mail:
                <input type="text" class="form-control" name="mail" />
                <br />Inquiry:
                <textarea type="text" class="form-control" name="comment" />
                <br />
                <input type="submit" class="btn btn-primary" value="Send" />
                <br />
                <br />
                <input type="reset" value="Reset" />
              </form>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallButton from "./CallButton";
export default {
  name: "Contact",
  components: {
    CallButton,
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#logo {
  height: 20px;
  padding-left: 0px;
}
hr {
  background-color: #e3e6e6;
}
.fa-envelope {
  margin-right: 20px;
}
.contact {
  width: 50%;
  align-self: center;
}
a.call-button.btn.btn-secondary {
  margin-right: center;
}
.page {
  flex-direction: column;
  padding-left: 20px;
  font-size: 20px;
}
section {
  margin-bottom: 10px;
}
a:hover {
  color: #007bff !important;
}
a {
  margin-bottom: 14px;
  display: inline-block;
  color: white !important;
}
.fa-envelope {
  font-size: 50px;
  margin-right: 40px;
  color: white !important;
}
h3 {
  color: #ff9898 !important;
}
/* h3 {
  text-align: center;
} */
.page {
  background-image: url("../assets/screen-5.png");
  background-color: grey;
  color: white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 50%;
  height: 100%;
  width: 100%;
  display: flex;
  animation: backgroundMove 120s ease-in-out infinite;
}
.col {
  background: #232f3e;
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
